import { makeStyles } from 'tss-react/mui'


export const useStyles = makeStyles()((theme)=> {
    return {
            fullWidth: {
                width: "100%"
            },
            halfWidth: {
                width: `calc(50% - ${theme.spacing(0.5)})`
            }
        }
})